/* global IntersectionObserver */
import React, { Suspense, useState, useCallback, useRef } from 'react';
import { node } from 'prop-types';
import LoadingFallback from './LoadingFallback';

function LazyLoadWhenInView({ children }) {
    const [isVisible, setIsVisible] = useState(false);
    const observerRef = useRef(null);
    const setRef = useCallback((node) => {
        if (!node) {
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
            return;
        }
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, {
            rootMargin: '0px',
            threshold: 0.1,
        });
        observer.observe(node);
        observerRef.current = observer;
    }, []);
    return (
        <Suspense
            fallback={<LoadingFallback />}
        >
            <div
                ref={setRef}
            >
                {isVisible ? children : null}
            </div>
        </Suspense>
    );
}

LazyLoadWhenInView.propTypes = {
    children: node,
};

export default LazyLoadWhenInView;
